import React, { useState } from 'react';
import { useShift } from '../../context/ShiftContext';
import { format, parseISO } from 'date-fns';
import { LogInIcon, FileTextIcon, RepeatIcon, UsersIcon, CalendarIcon, ClipboardIcon, DatabaseIcon } from 'lucide-react';
const ActivityLog = () => {
  const {
    activityLogs
  } = useShift();
  const [filter, setFilter] = useState<string>('all');
  const filteredLogs = filter === 'all' ? activityLogs : activityLogs.filter(log => log.category === filter);
  const getCategoryIcon = (category: string) => {
    const icons = {
      login: LogInIcon,
      request: FileTextIcon,
      trade: RepeatIcon,
      user: UsersIcon,
      holiday: CalendarIcon,
      shift: ClipboardIcon,
      data: DatabaseIcon
    };
    const Icon = icons[category as keyof typeof icons] || FileTextIcon;
    return <Icon size={16} data-id="element-30" />;
  };
  const getCategoryColor = (category: string) => {
    const colors = {
      login: 'bg-blue-100 text-blue-800',
      request: 'bg-green-100 text-green-800',
      trade: 'bg-purple-100 text-purple-800',
      user: 'bg-yellow-100 text-yellow-800',
      holiday: 'bg-pink-100 text-pink-800',
      shift: 'bg-indigo-100 text-indigo-800',
      data: 'bg-red-100 text-red-800'
    };
    return colors[category as keyof typeof colors] || 'bg-gray-100 text-gray-800';
  };
  return <div data-id="element-31">
      <div className="flex justify-between items-center mb-6" data-id="element-32">
        <h3 className="text-xl font-semibold text-gray-700" data-id="element-33">Activity Log</h3>
        <div className="flex space-x-2 flex-wrap" data-id="element-34">
          <button onClick={() => setFilter('all')} className={`px-3 py-1 text-sm rounded-md ${filter === 'all' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-35">
            All
          </button>
          <button onClick={() => setFilter('login')} className={`px-3 py-1 text-sm rounded-md ${filter === 'login' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-36">
            Logins
          </button>
          <button onClick={() => setFilter('request')} className={`px-3 py-1 text-sm rounded-md ${filter === 'request' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-37">
            Requests
          </button>
          <button onClick={() => setFilter('trade')} className={`px-3 py-1 text-sm rounded-md ${filter === 'trade' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-38">
            Trades
          </button>
          <button onClick={() => setFilter('user')} className={`px-3 py-1 text-sm rounded-md ${filter === 'user' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-39">
            Users
          </button>
          <button onClick={() => setFilter('holiday')} className={`px-3 py-1 text-sm rounded-md ${filter === 'holiday' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-40">
            Holidays
          </button>
          <button onClick={() => setFilter('shift')} className={`px-3 py-1 text-sm rounded-md ${filter === 'shift' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-41">
            Shifts
          </button>
          <button onClick={() => setFilter('data')} className={`px-3 py-1 text-sm rounded-md ${filter === 'data' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-42">
            Data
          </button>
        </div>
      </div>
      {filteredLogs.length > 0 ? <div className="bg-white shadow overflow-hidden sm:rounded-md" data-id="element-43">
          <ul className="divide-y divide-gray-200" data-id="element-44">
            {filteredLogs.map(log => <li key={log.id} data-id="element-45">
                <div className="px-4 py-4 sm:px-6 hover:bg-gray-50" data-id="element-46">
                  <div className="flex items-start" data-id="element-47">
                    <div className={`flex-shrink-0 p-2 rounded-full ${getCategoryColor(log.category)}`} data-id="element-48">
                      {getCategoryIcon(log.category)}
                    </div>
                    <div className="ml-4 flex-1" data-id="element-49">
                      <div className="flex items-center justify-between" data-id="element-50">
                        <p className="text-sm font-medium text-gray-900" data-id="element-51">
                          {log.action}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-52">
                          {format(parseISO(log.timestamp), 'MMM d, yyyy h:mm a')}
                        </p>
                      </div>
                      <p className="text-sm text-gray-600 mt-1" data-id="element-53">
                        {log.details}
                      </p>
                      {log.userName && <p className="text-xs text-gray-500 mt-1" data-id="element-54">
                          By: {log.userName}
                        </p>}
                    </div>
                  </div>
                </div>
              </li>)}
          </ul>
        </div> : <div className="text-center py-10" data-id="element-55">
          <p className="text-gray-500" data-id="element-56">No activity logs found.</p>
        </div>}
    </div>;
};
export default ActivityLog;